module.exports = __webpack_public_path__ + "static/img/image5.20ab6b51.png";